// extracted by mini-css-extract-plugin
export default {"rating":"sw-z","numberOfStars":"tw-z","count":"uw-z","barGraphSpacing":"vw-z","barGraph":"ww-z"};